export const ADD_TO_CART_OR_INCREASE_QUANTITY =
  "CART/ADD_TO_CART_OR_INCREASE_QUANTITY";
export const REMOVE_FROM_CART = "CART/REMOVE_FROM_CART";
export const CLEAR_CART = "CART/CLEAR_CART";
export const INCREASE_QUANTITY = "CART/INCREASE_QUANTITY";
export const DECREASE_QUANTITY = "CART/DECREASE_QUANTITY";
